import { afterValid } from '~/services/api/contracts/afterValid'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { DashboardPaymentsQuerySchema } from '~/services/api/generated'

// Dashboard\PaymentIndexRequest::rules (date_to after_or_equal date_from)
export const DashboardPayments = (_context: NoContext = {}) =>
  afterValid(DashboardPaymentsQuerySchema, (value, ctx) => {
    if (typeof value.date_from === 'string' && typeof value.date_to === 'string') {
      if (Date.parse(value.date_to) < Date.parse(value.date_from)) {
        ctx.addIssue({
          code: 'custom',
          message: 'The date to field must be a date after or equal to date from',
          path: ['date_to']
        })
      }
    }
  })
